"use client";

import { useMutation } from "@tanstack/react-query";

import { useAuthStore } from "@/modules/auth/stores/auth-store";

import { saveDashboardLayout } from "../services/dashboard";

import type { DashboardLayout } from "@/types";

/**
 * Persist the user's dashboard layout.
 *
 * Scoped invalidation rather than the global post-mutation sweep: reordering
 * cards only changes which widgets render and in what order, so refetching every
 * widget's DATA as well would be a lot of work for a drag-and-drop. The catalog
 * response carries the recomputed `visible` order, which is all that changed.
 */
export function useSaveDashboardLayout() {
  const companyUuid = useAuthStore((s) => s.companyAccount?.uuid);

  return useMutation({
    mutationFn: (layout: DashboardLayout) => saveDashboardLayout(layout),
    meta: { invalidates: [["dashboard", "catalog", companyUuid]] },
  });
}
